
    <fieldmagic-calendar-input
      class="fieldmagic-data-grid-datetime-cell-input"
      [standalone]="true"
      [(ngModel)]="value"
      [tooltip]="tooltip$ | async"
      (ngModelChange)="onChanged()"
      type="datetime"
    >
    </fieldmagic-calendar-input>
  